/**
 * Environment variables accessor
 *
 * This file replaces the previous constants.js approach with environment variables
 * loaded from .env files via dotenv.
 */

// Values are loaded from the appropriate .env file based on NODE_ENV
// and made available through process.env

export const personalUrl = process.env.PERSONAL_URL;
export const websiteUrl = process.env.WEBSITE_URL;
export const odaUrl = process.env.ODA_URL;
export const teamsUrl = process.env.TEAMS_URL;
export const developByCriteriaURL = process.env.DEVELOP_BY_CRITERIA_URL;
export const czKey = process.env.CZ_KEY;
export const configCatAppKey = process.env.CONFIG_CAT_APP_KEY;
export const viSystemUrl = process.env.VI_SYSTEM_URL;
export const czPrefix = process.env.CZ_PREFIX || "";
export const instancePrefix = process.env.INSTANCE_PREFIX || "";
export const stripeNAPublishableKey = process.env.STRIPE_NA_PUBLISHABLE_KEY;
export const stripeAUPublishableKey = process.env.STRIPE_AU_PUBLISHABLE_KEY;
export const landingPagePreviewUrl = process.env.LANDING_PAGE_PREVIEW_URL;

// Sentry Configuration
export const sentryDsn = process.env.SENTRY_DSN;
export const sentryEnableInDev = process.env.SENTRY_ENABLE_IN_DEV === 'true';
export const sentryTracesSampleRate = parseFloat(process.env.SENTRY_TRACES_SAMPLE_RATE || '0.2');
export const sentryAuthToken = process.env.SENTRY_AUTH_TOKEN;
export const appVersion = process.env.VERSION || '0.1.0';

// Add other environment variables as needed
